/* Ruginza assistant — assets/rga.js
   Home view first, then chat. Streams from /chat/stream, falls back to /chat.
   All copy lives here; the snippet only supplies data-* from Liquid. */
(function () {
  var root = document.getElementById('rga');
  if (!root) return;
  var EP = (root.dataset.endpoint || '').trim();
  if (!EP) return;

  var JA = /(^|\.)ruginza\.jp$/i.test(location.hostname);
  var PROD = root.dataset.product || '';

  var T = JA ? {
    eyebrow: 'Ruginza',
    g1: 'いらっしゃいませ。', g2: 'ラグ選びのお手伝いをします。',
    sub: 'サイズ、素材、配送のことまで、何でもお尋ねください。',
    online: 'オンライン · 通常すぐに返信します',
    cta: 'チャットを始める',
    qh: 'よくあるご相談', qhProd: 'このラグについて',
    chat: 'ラグ選びのお手伝い', back: 'ホームに戻る', close: '閉じる', sound: '返信音',
    ph: 'どんなお部屋にお使いですか？',
    hello: 'こんにちは。お部屋の広さやご用途をお聞かせください。ぴったりの一枚をお探しします。',
    viewing: 'ご覧の商品',
    foot: 'AIによるご案内です。お急ぎの方は contact@ruginza.jp へ。',
    err: '申し訳ございません、うまく繋がりませんでした。少し時間をおいてお試しください。',
    st: { search_products:'お取り扱いの中からお探ししています', get_product:'商品を確認しています',
          size_advisor:'サイズを計算しています', escalate:'担当者におつなぎしています',
          _:'お調べしています' },
    quick: [
      { i:'ruler', t:'サイズ選びの相談',    s:'お部屋に合う一枚を',       q:'ラグのサイズ選びについて相談したいです。' },
      { i:'drop',  t:'お手入れ・素材について', s:'ウール、シルク、遊び毛',   q:'お手入れと素材について教えてください。' },
      { i:'box',   t:'配送・返品について',   s:'送料、納期、返品の条件',   q:'配送と返品について教えてください。' },
      { i:'gem',   t:'一点ものについて',     s:'手織りならではの個体差',   q:'一点ものについて教えてください。' }
    ],
    quickProd: [
      { i:'ruler', t:'このラグのサイズを教えて', s:'寸法と実寸の目安',     q:'このラグのサイズを教えてください。' },
      { i:'room',  t:'私の部屋に合いますか？',   s:'お部屋に合わせて確認',  q:'私の部屋に合うか相談したいです。' },
      { i:'drop',  t:'お手入れ方法は？',        s:'日々のお手入れと洗い',  q:'このラグのお手入れ方法を教えてください。' }
    ]
  } : {
    eyebrow: 'Ruginza',
    g1: 'Hello.', g2: 'Let’s find your rug.',
    sub: 'Size, materials, delivery — ask us anything.',
    online: 'Online · we usually reply right away',
    cta: 'Start a conversation',
    qh: 'Common questions', qhProd: 'About this rug',
    chat: 'Rug advice', back: 'Back to start', close: 'Close', sound: 'Reply sound',
    ph: 'Tell me about the room…',
    hello: 'Hello. Tell me the room and what the rug is for, and I’ll find the right one.',
    viewing: 'Viewing',
    foot: 'AI assistance. For anything urgent, email contact@ruginza.jp.',
    err: 'Sorry — I couldn’t connect. Please try again in a moment.',
    st: { search_products:'Checking stock', get_product:'Looking up the rug',
          size_advisor:'Working out the size', escalate:'Passing this to a colleague',
          _:'Looking into it' },
    quick: [
      { i:'ruler', t:'Choosing a size',      s:'What fits your room',        q:'I need help choosing a rug size.' },
      { i:'drop',  t:'Care & materials',     s:'Wool, silk, shedding',       q:'Tell me about care and materials.' },
      { i:'box',   t:'Delivery & returns',   s:'Shipping, timing, policy',   q:'Tell me about delivery and returns.' },
      { i:'gem',   t:'One-of-a-kind pieces', s:'Why every rug differs',      q:'Tell me about one-of-a-kind rugs.' }
    ],
    quickProd: [
      { i:'ruler', t:'What size is this rug?', s:'Dimensions and tolerance', q:'What size is this rug?' },
      { i:'room',  t:'Will it fit my room?',   s:'Checked against your room', q:'Will this rug fit my room?' },
      { i:'drop',  t:'How do I care for it?',  s:'Everyday care and washing', q:'How do I care for this rug?' }
    ]
  };

  var ICON = {
    ruler:'<path d="M2 11l9-9 5 5-9 9zM6 7l1.6 1.6M8.6 4.4L10.2 6"/>',
    drop: '<path d="M9 2s5 5.2 5 8.4A5 5 0 0 1 4 10.4C4 7.2 9 2 9 2z"/>',
    box:  '<path d="M2.5 5.5L9 2l6.5 3.5v7L9 16l-6.5-3.5zM2.5 5.5L9 9m0 0l6.5-3.5M9 9v7"/>',
    gem:  '<path d="M4.5 2.5h9l2.5 4L9 15.5 1.5 6.5zM1.5 6.5h15M6.5 2.5L9 15.5l2.5-13"/>',
    room: '<path d="M2 7.5L9 2.5l7 5V15H2zM6.5 15v-4.5h5V15"/>'
  };
  function icon(n){
    return '<svg viewBox="0 0 18 18" width="16" height="16" fill="none" stroke="currentColor" '
      + 'stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + (ICON[n]||ICON.gem) + '</svg>';
  }
  var CHEV = '<svg viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" '
    + 'stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M4.5 2.5L8 6l-3.5 3.5"/></svg>';

  var q = function (s) { return root.querySelector(s); };
  var panel=q('.rga-panel'), launch=q('.rga-launch'), log=q('.rga-log'), form=q('.rga-form'),
      input=q('#rga-input'), send=q('.rga-send'), soundBtn=q('.rga-sound'), backBtn=q('.rga-back'),
      cid=null, busy=false, sound=false, greeted=false;

  root.setAttribute('lang', JA ? 'ja' : 'en');

  /* ---------------- home ---------------- */
  q('.rga-hero__eyebrow').textContent = T.eyebrow;
  q('.rga-hero__g').innerHTML = '<span></span><span></span>';
  q('.rga-hero__g').children[0].textContent = T.g1;
  q('.rga-hero__g').children[1].textContent = T.g2;
  q('.rga-hero__sub').textContent = T.sub;
  q('.rga-status__t').textContent = T.online;
  q('.rga-cta').textContent = T.cta;
  q('.rga-bar__t').textContent = T.chat;
  q('.rga-foot').textContent = T.foot;
  q('.rga-sr').textContent = T.ph;
  input.placeholder = T.ph;
  backBtn.setAttribute('aria-label', T.back);
  q('.rga-close').setAttribute('aria-label', T.close);
  soundBtn.setAttribute('aria-label', T.sound); soundBtn.title = T.sound;
  launch.setAttribute('aria-label', T.chat);

  // Product context: on a PDP the home view leads with the rug, and the starters are about it.
  var starters = T.quick, qhead = T.qh;
  if (PROD) {
    starters = T.quickProd; qhead = T.qhProd;
    var pw = q('.rga-prod');
    pw.style.display = 'flex';
    q('.rga-prod__l').textContent = T.viewing;
    q('.rga-prod__t').textContent = root.dataset.productTitle || '';
    var pi = root.dataset.productImage || '';
    if (pi) {
      if (pi.indexOf('cdn.shopify.com') > -1) pi += (pi.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var im = document.createElement('img');
      im.className = 'rga-prod__img'; im.alt = ''; im.decoding = 'async';
      im.addEventListener('error', function () {
        var s = document.createElement('span'); s.className = 'rga-prod__img';
        if (im.parentNode) im.parentNode.replaceChild(s, im);
      });
      im.src = pi;
      pw.insertBefore(im, pw.firstChild);
    } else {
      var sp = document.createElement('span'); sp.className = 'rga-prod__img';
      pw.insertBefore(sp, pw.firstChild);
    }
  }
  q('.rga-qh').textContent = qhead;
  var qwrap = q('.rga-q');
  starters.forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rga-qr';
    b.innerHTML = '<span class="rga-qr__i">' + icon(s.i) + '</span>'
      + '<span class="rga-qr__b"><span class="rga-qr__t"></span>'
      + '<span class="rga-qr__s"></span></span>'
      + '<span class="rga-qr__c">' + CHEV + '</span>';
    b.querySelector('.rga-qr__t').textContent = s.t;
    b.querySelector('.rga-qr__s').textContent = s.s;
    b.addEventListener('click', function () { toChat(); ask(s.q); });
    qwrap.appendChild(b);
  });

  /* ---------------- sound (off by default) ---------------- */
  try { sound = localStorage.getItem('rga_sound') === '1'; } catch (e) {}
  soundBtn.setAttribute('aria-pressed', sound ? 'true' : 'false');
  soundBtn.addEventListener('click', function () {
    sound = !sound;
    soundBtn.setAttribute('aria-pressed', sound ? 'true' : 'false');
    try { localStorage.setItem('rga_sound', sound ? '1' : '0'); } catch (e) {}
    if (sound) chime();
  });
  function chime() {
    if (!sound || !window.AudioContext) return;
    try {
      var a = new AudioContext(), o = a.createOscillator(), g = a.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(660, a.currentTime);
      o.frequency.exponentialRampToValueAtTime(880, a.currentTime + .09);
      g.gain.setValueAtTime(.0001, a.currentTime);
      g.gain.exponentialRampToValueAtTime(.05, a.currentTime + .02);
      g.gain.exponentialRampToValueAtTime(.0001, a.currentTime + .34);
      o.connect(g); g.connect(a.destination);
      o.start(); o.stop(a.currentTime + .36);
      o.onended = function () { a.close(); };
    } catch (e) {}
  }

  /* ---------------- helpers ---------------- */
  function ctx() {
    var d = root.dataset, c = { template: d.template || null, path: location.pathname };
    // The market the customer is actually in, so the server quotes the price THIS page shows.
    var S = window.Shopify || {};
    if (S.country) c.country = String(S.country).slice(0, 2);
    if (S.currency && S.currency.active) c.currency = String(S.currency.active).slice(0, 3);
    if (d.product) { c.product_handle = d.product; c.product_title = d.productTitle || null; }
    if (d.collection) c.collection_handle = d.collection;
    return c;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function linkify(s) {
    return esc(s).replace(/https:\/\/(?:www\.)?ruginza\.(?:jp|com)\/[^\s<)）、。]+/g,
      function (u) { return '<a href="' + u + '" target="_blank" rel="noopener">' + u + '</a>'; });
  }
  function bottom() { log.scrollTop = log.scrollHeight; }
  function msg(role, text) {
    var p = document.createElement('p');
    p.className = 'rga-m rga-m--' + role;
    p.innerHTML = role === 'user' ? esc(text) : linkify(text);
    log.appendChild(p); bottom(); return p;
  }
  function cards(list) {
    if (!list || !list.length) return;
    var wrap = document.createElement('div'); wrap.className = 'rga-cards';
    list.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'rga-card'; a.href = p.url; a.target = '_blank'; a.rel = 'noopener';
      // Thumbnail from the CDN: the catalogue stores >1 MB PNGs for a 64x80 box.
      // NO loading="lazy" — inside this scrolling log the lazy heuristic never fires and
      // the images silently never load.
      var src = p.image || '';
      if (src.indexOf('cdn.shopify.com') > -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var thumb;
      if (src) {
        thumb = document.createElement('img');
        thumb.className = 'rga-card__img'; thumb.alt = ''; thumb.decoding = 'async';
        thumb.width = 64; thumb.height = 80;
        thumb.addEventListener('error', function () {
          var ph = document.createElement('span'); ph.className = 'rga-card__img';
          if (thumb.parentNode) thumb.parentNode.replaceChild(ph, thumb);
        });
        thumb.src = src;
      } else { thumb = document.createElement('span'); thumb.className = 'rga-card__img'; }
      var meta = [p.size_cm, p.material].filter(Boolean).join(' · ');
      a.innerHTML = '<span class="rga-card__b">'
        + '<span class="rga-card__t">' + esc(p.title) + '</span>'
        + (meta ? '<span class="rga-card__meta">' + esc(meta) + '</span>' : '')
        + '<span class="rga-card__p">' + esc(p.price_display) + '</span></span>';
      a.insertBefore(thumb, a.firstChild);
      wrap.appendChild(a);
    });
    log.appendChild(wrap); bottom();
  }
  function typing() {
    var d = document.createElement('div');
    d.className = 'rga-typing';
    d.innerHTML = '<i></i><i></i><i></i><span class="rga-typing__l"></span>';
    log.appendChild(d); bottom(); return d;
  }
  function status(el, tool) {
    if (!el) return;
    var l = el.querySelector('.rga-typing__l');
    if (l) l.textContent = (T.st[tool] || T.st._) + '…';
  }

  /* ---------------- views ---------------- */
  function toChat() {
    root.classList.remove('view-home'); root.classList.add('view-chat');
    if (!greeted) { greeted = true; msg('bot', T.hello); }
    setTimeout(function () { input.focus(); }, 60);
  }
  function toHome() { root.classList.remove('view-chat'); root.classList.add('view-home'); }
  // One soft pulse when a reply lands with the panel shut. Toggling the class off and
  // forcing a reflow restarts the animation; without that a second reply is silent.
  function notify() {
    if (root.classList.contains('is-open')) return;
    launch.classList.remove('is-notify');
    void launch.offsetWidth;
    launch.classList.add('is-notify');
  }
  launch.addEventListener('animationend', function () { launch.classList.remove('is-notify'); });
  /* ---------------- 1b: stay clear of the product form ----------------
     The launcher sits in the bottom-right corner. On a product page the Add to cart row
     (button + wishlist heart) scrolls through that corner, and the launcher would cover the
     heart and the button's edge. While any of these overlaps the launcher's resting spot,
     lift the whole widget just above it; drop back once it has passed. Not while the panel
     is open — the panel is then the focus, and lifting it could push its top off screen. */
  // batch-23: also clear the cart page's checkout button and the product page's sticky buy bar.
  var LIFT_SEL = 'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], '
               + '.wk-button, .shopify-payment-button, button[name="checkout"], .cart__checkout, .rz-sticky-atc';
  var liftPx = 0, liftRaf = 0;
  function measureLift() {
    liftRaf = 0;
    var need = 0;
    if (!root.classList.contains('is-open')) {
      // Resting (un-lifted) spot from LAYOUT offsets, which ignore `translate` and any
      // transition in flight. getBoundingClientRect mid-transition gave wrong lifts.
      var top = root.offsetTop + launch.offsetTop, left = root.offsetLeft + launch.offsetLeft;
      var bottom = top + launch.offsetHeight, right = left + launch.offsetWidth;
      var els = document.querySelectorAll(LIFT_SEL);
      for (var i = 0; i < els.length; i++) {
        if (root.contains(els[i])) continue;
        var r = els[i].getBoundingClientRect();
        if (!r.width || !r.height) continue;
        if (r.left < right && r.right > left && r.top < bottom && r.bottom > top)
          need = Math.max(need, Math.ceil(bottom - r.top + 8));
      }
    }
    if (need !== liftPx) { liftPx = need; root.style.setProperty('--rga-lift', need + 'px'); }
  }
  function queueLift() {
    if (liftRaf) return;
    // rAF never fires in a hidden page (background tab, hidden preview pane); a timer does.
    liftRaf = document.hidden ? setTimeout(measureLift, 50) : requestAnimationFrame(measureLift);
  }
  if (document.querySelector('form[action*="/cart/add"], button[name="checkout"]')) {
    addEventListener('scroll', queueLift, { passive: true });
    addEventListener('resize', queueLift);
    // the wishlist heart is injected by its app after load
    [0, 800, 2500].forEach(function (t) { setTimeout(queueLift, t); });
  }

  function open() {
    root.classList.remove('is-closing'); root.classList.add('is-open');
    queueLift();
    launch.setAttribute('aria-expanded', 'true');
    if (!root.classList.contains('view-chat')) root.classList.add('view-home');
  }
  function shut() {
    root.classList.add('is-closing'); root.classList.remove('is-open');
    launch.setAttribute('aria-expanded', 'false');
    setTimeout(function () { root.classList.remove('is-closing'); launch.focus(); queueLift(); }, 170);
  }
  launch.addEventListener('click', function () {
    root.classList.contains('is-open') ? shut() : open();
  });
  q('.rga-close').addEventListener('click', shut);
  backBtn.addEventListener('click', toHome);
  q('.rga-cta').addEventListener('click', function () { toChat(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) shut();
  });
  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 104) + 'px';
    input.classList.toggle('is-full', input.scrollHeight > 104);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit(); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value.trim();
    if (!t) return;
    input.value = ''; input.style.height = 'auto';
    ask(t);
  });

  /* ---------------- send ---------------- */
  function ask(text) {
    if (busy) return;
    busy = true; send.disabled = true;
    msg('user', text);
    var dots = typing(), bot = null, buf = '';

    function land(t2, prods) {
      if (dots) { dots.remove(); dots = null; }
      if (!bot) bot = msg('bot', t2 || T.err); else bot.innerHTML = linkify(t2 || T.err);
      cards(prods); chime(); notify();
    }
    function finish() { busy = false; send.disabled = false; input.focus(); }

    fetch(EP.replace(/\/$/, '') + '/chat/stream', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: text, conversation_id: cid, page_context: ctx() })
    }).then(function (r) {
      if (!r.ok || !r.body || !window.TextDecoder) throw new Error('nostream');
      var reader = r.body.getReader(), dec = new TextDecoder(), acc = '', prods = null;
      return (function pump() {
        return reader.read().then(function (res) {
          if (res.done) return;
          acc += dec.decode(res.value, { stream: true });
          var parts = acc.split('\n\n'); acc = parts.pop();
          parts.forEach(function (chunk) {
            var line = chunk.trim();
            if (line.indexOf('data:') !== 0) return;
            var ev; try { ev = JSON.parse(line.slice(5).trim()); } catch (err) { return; }
            if (ev.t === 'open') cid = ev.conversation_id;
            else if (ev.t === 'status') { if (!dots) dots = typing(); status(dots, ev.tool); }
            else if (ev.t === 'text') {
              buf += ev.d;
              if (!bot) { if (dots) { dots.remove(); dots = null; } bot = msg('bot', ''); }
              bot.innerHTML = linkify(buf); bottom();
            }
            else if (ev.t === 'products') prods = ev.v;
            else if (ev.t === 'done') {
              if (dots) { dots.remove(); dots = null; }
              if (!bot) bot = msg('bot', buf || T.err);
              cards(prods); chime(); notify();
            }
            else if (ev.t === 'error') land(T.err, null);
          });
          return pump();
        });
      })();
    }).catch(function () {
      if (buf) { finish(); return; }
      return fetch(EP.replace(/\/$/, '') + '/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, conversation_id: cid, page_context: ctx() })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { cid = d.conversation_id; land(d.text, d.products); })
        .catch(function () { land(T.err, null); });
    }).finally(finish);
  }
})();